export default "__VITE_ASSET__Dj0XUg1S__"